import { useState } from 'react'
import { Button, Alert, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, FormControl } from 'react-bootstrap'
// import useActions from 'hooks/use-actions'
import useAPI from 'hooks/use-api'
import { useDispatch } from 'react-redux'
import { updateEvent } from 'store/event'

const ImportConfigButton = ({ event }) => {
    
    const [modal, setModal] = useState(false)
    const [config, setConfig] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const dispatch = useDispatch()
    const api = useAPI('/admin')

    const handleImport = async () => {
        try {
            JSON.parse(config)
            setError(null)
        } catch (error) {
            setError(error)
        }
        setLoading(true)
        api.post(`/event/${event.id}/import`, JSON.parse(config))
        .then((data) => {
            dispatch(updateEvent({
                features: [...event.features, ...data.features].filter((f, i, a) => a.findIndex((f2) => f2.name === f.name) === i),
                categories: [...event.categories, ...data.categories].filter((c, i, a) => a.findIndex((c2) => c2.name === c.name) === i),
                entities: [...event.entities, ...data.entities].filter((e, i, a) => a.findIndex((e2) => e2.name === e.name) === i)
            }))
            setError(null)
            setModal(false)
        })
        .catch(setError)
        .finally(() => setLoading(false))
    }

    const handleChange = (e) => {
        setConfig(e.target.value)
    }

    return (
        <>
            <Button variant='link' size='sm' onClick={() => setModal(true)} className='px-0 text-secondary'>Import config</Button>
            <Modal show={!!modal} onHide={() => setModal()} centered>
                <ModalHeader>Import config</ModalHeader>
                <ModalBody>
                    <FormControl as='textarea' size='sm' value={config} onChange={handleChange} rows={8} className='font-monospace' />
                    {error && <Alert variant='danger' className='small mb-0 mt-2'>{error.message}</Alert>}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleImport} disabled={!config || loading}>{loading ? <Spinner size='sm' color='white' /> : 'Import'}</Button>
                    <Button variant='link' onClick={() => setModal()}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </>
    )

}

export default ImportConfigButton